"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";
function EpisodeList() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="flex flex-col gap-6">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-64 w-full animate-pulse rounded-xl bg-muted/50 md:h-48" />)}
      </div>;
  }
  if (error) {
    return <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-6 text-destructive">
        Failed to load recent episodes. Please try again later.
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="rounded-lg border border-border bg-card p-12 text-center text-muted-foreground">
        No episodes available at the moment.
      </div>;
  }
  return <div className="flex flex-col gap-6">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="group relative grid grid-cols-12 gap-6 rounded-xl border border-secondary bg-card p-4 transition-all duration-500 ease-out hover:-translate-y-1 hover:border-primary hover:shadow-lg md:p-6">
          {}
          <div className="col-span-12 relative overflow-hidden rounded-lg bg-muted md:col-span-4">
            {}
            <div className="absolute inset-0 z-10 bg-primary/20 mix-blend-overlay transition-opacity duration-500 group-hover:opacity-0" />
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/generic_podcast_cover.png"} alt={post.title} className="aspect-video h-full w-full object-cover grayscale contrast-125 transition-all duration-500 group-hover:grayscale-0 group-hover:contrast-100 md:aspect-auto" />
          </div>

          {}
          <div className="col-span-12 flex flex-col justify-between md:col-span-8">
            <div>
              <div className="mb-3 font-mono text-xs font-semibold tracking-wider text-primary uppercase">
                {post.categories?.[0]?.name || "EPISODE"}
              </div>
              <h3 className="mb-3 font-default text-2xl font-bold leading-tight text-foreground">
                <Link to={post.link || "#"} className="hover:text-primary hover:underline hover:decoration-primary/50 hover:underline-offset-4">
                  {post.title}
                </Link>
              </h3>
              <div className="line-clamp-3 font-default text-base text-muted-foreground" dangerouslySetInnerHTML={{
            __html: post.excerpt || ""
          }} />
            </div>

            <div className="mt-6 flex items-center">
              <Button variant="ghost" className="gap-2 pl-0 font-default font-medium text-foreground hover:bg-transparent hover:text-primary" asChild>
                <Link to={post.link || "#"}>
                  <Play className="size-5" strokeWidth={1.5} />
                  Play Episode
                </Link>
              </Button>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function RecentEpisodes() {
  const wp_query_params = {
    post_type: "post",
    per_page: 4,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="recent-episodes" className="bg-secondary py-16 md:py-24">
      <div className="container mx-auto max-w-5xl px-4 md:px-6">
        <div className="mb-10 md:mb-16">
          <h2 className="font-default text-3xl font-bold text-foreground md:text-4xl">
            Recent Episodes
          </h2>
        </div>
        
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 4,
        orderby: "date",
        order: "desc"
      }}>
          <EpisodeList />
        </PostsProvider>
      </div>
    </section>;
}